<template>
  <div class="tokens box">
    <div v-if="search" class="token" v-for="[token, count] in tokens" @click="applyToken(token)">
      {{ token }}
    </div>
  </div>
</template>

<script>
  import { mapState } from 'vuex'
  export default {
    name: 'tokens',
    computed: {
      ...mapState('destiny/filters', ['search', 'tokens'])
    },
    methods: {
      applyToken (newToken) {
        const tokens = this.$store.state.destiny.filters.search.split(' ')
        const search = (tokens.slice(0, tokens.length - 1).join(' ') + ' ' + newToken).trim()
        this.$store.commit('destiny/filters/updateSearch', {search: search})
        this.$emit('applied', newToken)
      }
    },
    components: {}
  }
</script>

<style lang="scss">
  @import "../styles/settings";

  .tokens {
    .token {
      padding: .5rem;
      font-size: 1rem;
      box-shadow: $default-shadow;
      background: $background;
      margin: .5rem 0;
      cursor: pointer;
      &:hover {
        background: lighten($background, 5%);
      }
    }
  }
</style>



// WEBPACK FOOTER //
// Tokens.vue?20316e3e